import { safeHTML } from '../../../../../utils/safeHTML';

export default function Info({ title, text }) {
  return (
    <>
      {title && <div className={'achievement__title'}>{safeHTML(title)}</div>}
      {text && <div className={'achievement__text'}>{safeHTML(text)}</div>}
    </>
  );
}
